import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

import { TEXT_POSITION } from './ImageCard';

export const Heading = styled.h3`
  text-align: center;
  overflow-x: hidden;
  font-weight: 500;
  margin: 30px 0 50px;
`;

export const Lines = styled.span`
  position: relative;

  &::before,
  &::after {
    content: '';
    width: 99999px;
    height: 2px;
    background: #dfe0e0;
    position: absolute;
    top: 50%;
  }

  &::before {
    right: 100%;
    margin-right: 25px;
  }

  &::after {
    left: 100%;
    margin-left: 25px;
  }
`;

export const Grid = styled.div`
  ${breakpoint('tablet')`
    margin-right: -20px;
  `}

  ${({ center }) => center && 'text-align: center;'}

  &::after {
    content: '';
    clear: both;
    display: block;
  }
`;

export const GridItem = styled.div`
  margin-bottom: 10px;
  width: 100%;

  ${breakpoint('tablet')`
    margin-bottom: 30px;
    padding-right: 20px;

    width: ${({ count, stretch }) => (count < 3 && stretch ? `${100 / count}%;` : '33.3333%;')};

    ${({ center, stretch }) => (center && !stretch ? 'display: inline-block;' : 'float: left;')}
  `}
`;

export const Image = styled.img`
  width: 100%;
  display: block;
  height: auto;
`;

export const CardWrapper = styled.div`
  position: relative;
`;

export const ContentWrapper = styled.div`
  position: ${({ position }) => (position === TEXT_POSITION.bottom ? 'relative' : 'absolute')};
  bottom: ${({ position }) => (position === TEXT_POSITION.bottom ? '0' : '40px')};
  left: 0;
  width: 100%;
  height: auto;

  ${({ position }) =>
    position === TEXT_POSITION.default &&
    `
    text-shadow: 0 0 20px #000;
    text-align: center;
  `}

  ${({ position }) =>
    position === TEXT_POSITION.bottom &&
    `
    padding: 25px;
    background: #F1F2F3;
    color: #333333;
    text-align: left;
  `}
`;

export const StyledHeading = styled.h4`
  margin: 0;
  color: ${({ dark }) => (dark ? '#000' : '#fff')};
  padding: ${({ dark }) => (dark ? '0' : '0 15px')};
  font-weight: 400;
`;

export const WrappingLink = styled.a`
  display: inline-block;
`

export const StyledLink = styled.a`
  &, &:visited, &:link {
    align-self: flex-start;
    color: #C23127;
    text-transform: uppercase;
    font-weight: 500;
    border-bottom: 1px dotted #fbc7c4;
    justify-self: flex-end;
    margin: auto 0 0;
  }
`;

export const StyledDate = styled.span`
  color: ${({ dark }) => (dark ? '#333' : '#fff')};
  font-weight: 400;
  text-transform: uppercase;
`;
